export const GET_INVESTOR_NOTIFICATION_SUCCESS =
    'GET_INVESTOR_NOTIFICATION_SUCCESS';
export const SET_INVESTOR_NOTIFICATION_LOADING =
    'SET_INVESTOR_NOTIFICATION_LOADING';
